<template>
  <div class="upload-image" :class="size ? 'upload-image-' + size : ''">
    <!-- 展示区 -->

    <div
      v-if="value && value.length > 0"
      v-for="(file, index) in fileList"
      :key="file.id"
      class="file-img mr-1 mb-3 cursor-pointer"
      :class="{ isImg: file.type === 'img' }"
      :style="`background-image: url(${file.url});`"
      @click="downloadFile(file)"
    >
      <b-badge class="file-name">
        {{ file.label || file.originalName }}
      </b-badge>
      <feather-icon
        v-if="!readonly && !disabled"
        class="delete-btn"
        icon="XIcon"
        size="20"
        @click.stop="clearImg(index)"
      />
    </div>

    <!-- 上传 -->

    <template v-if="!disabled">
      <a-upload
        v-if="
          limitData > 0
            ? fileList.length < limitData && !readonly
            : fileList.length < limit && !readonly
        "
        name="avatar"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :custom-request="uploadFile"
        :disabled="uploadLoading || disabled"
      >
        <div>
          <a-icon v-if="!disabled" :type="uploadLoading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">
            <template v-if="!disabled">
              {{ $t('_components.btns.upload') }}
            </template>
          </div>
        </div>
      </a-upload>
    </template>
  </div>
</template>

<script>
import COMMONAPI from '@/api/common'
import { BBadge } from 'bootstrap-vue'
import { getFileType } from '@/util/util'

export default {
  name: 'CUpload',
  components: {
    BBadge,
  },
  props: {
    value: {
      type: [Array, String, Number, Object],
      default: () => [],
    },
    limit: {
      type: Number,
      default: 10,
    },
    size: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadLoading: false,
      uploadObj: {
        oldCount: 0,
        newCount: 0,
      },
      fileList: [],
      limitData: -1,
    }
  },
  watch: {
    fileList(e) {
      if (Array.isArray(e)) {
        this.$emit('input', e)
      }
    },
  },
  created() {
    setTimeout(() => {
      if (Array.isArray(this.value)) {
        this.value.forEach((file) => {
          const id = file.attachId || file.id
          const fObj = this.getImgSrc(file)
          this.fileList.push({
            id,
            attachId: id,
            label: fObj.label,
            url: fObj.url,
            value: fObj.value,
          })
        })
      } else if (typeof this.value === 'object' && this.value.id) {
        const id = this.value.attachId || this.value.id
        const fObj = this.getImgSrc(this.value)
        this.fileList = [
          {
            id,
            attachId: id,
            label: fObj.label,
            url: fObj.url,
            value: fObj.value,
          },
        ]
        this.limitData = 1
      }
    }, 1000 * 2)
  },
  methods: {
    getImgSrc(f) {
      const file = f
      const labelKey = file.label ? 'label' : 'originalName'
      const valueKey = file.value ? 'value' : 'link'
      const type = getFileType(file[labelKey])
      if (type === 'img') {
        file.type = 'img'
        file.url = file[valueKey]
      } else {
        file.url = `/img/litimg/${type}.png`
      }
      file.label = file[labelKey]
      file.value = file[valueKey]
      return file
    },
    uploadFile(params) {
      this.uploadObj.oldCount += 1
      this.uploadLoading = true
      if (this.uploadObj.newCount < 1) {
        this.$emit('update:loading', true)
      }
      COMMONAPI.upload('file', params.file)
        .then((res) => {
          this.uploadObj.newCount += 1
          if (this.uploadObj.oldCount === this.uploadObj.newCount) {
            this.uploadLoading = false
          }
          this.$emit('update:loading', false)
          this.uploadAfter(res.data)
        })
        .catch((err) => {
          this.uploadLoading = false
          this.$emit('update:loading', false)
        })
    },
    uploadAfter(response) {
      const res = response.data
      res.url = this.getImgSrc(res).value
      this.fileList.push(res)
      this.$emit('change', this.fileList)
    },
    clearImg(index) {
      this.fileList.splice(index, 1)
      this.$emit('change', this.fileList)
    },
    downloadFile(item) {
      if (item.value) {
        const url = item.value
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const fileName = item.label
        link.setAttribute('download', fileName)
        link.setAttribute('target', '_blank')
        link.click()
      }
    },
  },
}
</script>

<style lang="scss">
.upload-image {
  display: flex;
  flex-wrap: wrap;
  .avatar-uploader > .ant-upload {
    width: 100px;
    height: 100px;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }
  .ant-upload-picture-card-wrapper {
    width: auto;
  }
  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
  .file-img {
    position: relative;
    width: 100px;
    height: 100px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% auto;
    transition: all 0.3s;
    &:hover {
      .delete-btn {
        opacity: 1;
      }
    }
    .delete-btn {
      cursor: pointer;
      transition: all 0.3s;
      opacity: 0;
      position: absolute;
      right: -5px;
      top: -5px;
      border-radius: 50%;
      background-color: #f56c6c;
      color: #fff;
    }
  }
  .isImg {
    &:hover {
      background-size: 120% auto;
    }
  }
  .file-name {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    bottom: -23px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.upload-image-sm {
  .avatar-uploader > .ant-upload {
    width: 64px;
    height: 64px;
  }
  .file-img {
    width: 64px;
    height: 64px;
  }
}
</style>
